module.exports = __webpack_public_path__ + "static/img/11.42f97e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/11.jpg
// module id = FZaq
// module chunks = 1